module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18477/js/img/valuePropModals/FormConditionalLogic/ValueProp3.svg"